module.exports = __webpack_public_path__ + "514dd07812ab0434327d7bf21a004e39.jpg";